<template>
  <div>
    <div class="check-center">
      <p class="check-text">Query express delivery</p>
      <ByForm :rules="rules" :model="formData" ref="ruleForm">
        <div class="check-form_flex check-form__group">
          <ByFormItem prop="from" required class="check-form-item">
            <ByAutocomplete
            :key='componentKey'
              ref="from"
              placeholder="Origin City"
              v-model="formData.fromLabel"
              :fetchSuggestions="
                hotCityActive ? 
                (queryString, cb) => fetchSuggestions(queryString, cb, startHotDatas) :
                (queryString, cb) => fetchSuggestions(queryString, cb, startAirDatas)
              "
              :tabType='componentKey > 0'
              valueKey="value"
              labelKey="label"
              @focus='()=>{
              }'
              @select="
                (item) => {
                  formData.from = item.value;
                  formData.startItem = item;
                  $refs['end'].focus();
                  $refs['from'].isColse = false;
                }
              "
            >
              <template slot="prefix">
                <svg-icon size="20" name="juxing1"></svg-icon>
                <span>From : </span>
              </template>
              <template v-if="item" slot-scope="{ item }">
                <span style="margin-left: 20px" class="name">{{ item.label }}</span>
                <!-- <span class="addr">{{ item.AirportCode3 }}</span> -->
              </template>
              <template slot="tabtype">
                <div class="tabtype">
                  <div @click="changeType(1)" :class="{'active':hotCityActive}">Hot</div>
                  <div @click="changeType(2)" :class="{'active':allCityActive}">All</div>
                </div>
              </template>
            </ByAutocomplete>
          </ByFormItem>
          <ByFormItem prop="end" required class="check-form-item">
            <ByAutocomplete
              ref="end"
              @focus='()=>{
                componentKey = 0
              }'
              placeholder="Destination Country"
              v-model="formData.endLabel"
              :fetchSuggestions="
                (queryString, cb) => fetchSuggestions(queryString, cb, endAirDatas)
              "
              valueKey="value"
              labelKey="label"
              @select="
                (item) => {
                  formData.end = item.value;
                  formData.endItem = item;
                  $refs['unit'].focus();
                }
              "
            >
              <template slot="prefix">
                <svg-icon size="20" name="juxing1"></svg-icon>
                <span>To : </span>
              </template>
              <template v-if="item" slot-scope="{ item }">
                <span style="margin-left: 70px" class="name">{{ item.label }}</span>
                <span style="float: right" class="name">{{ item.CountryNameEn }}</span>
                <!-- <span class="addr">{{ item.AirportCode3 }}</span> -->
              </template>
            </ByAutocomplete>
          </ByFormItem>
        </div>
        <div class="check-form_flex check-form__group">
          <ByFormItem prop="unit" required class="check-form-item">
            <CheckInput
              ref="unit"
              maxlength="4"
              onkeyup="value=value.replace(/^(0+)|[^\d]+/g,'')"
              v-model="formData.unit"
              placeholder="Total Unit"
            >
              <template slot="prefix">
                <svg-icon size="20" name="juxing3"></svg-icon>
              </template>
              <template slot="custom_suffix">
                <CheckSelect
                  v-model="formData.unitType"
                  style="width: 130px"
                  :data="[
                    { value: 'CTNS', label: 'Carton' },
                    { value: 'PLTS', label: 'Pallet' },
                    { value: 'WOODEN CASE', label: 'Wooden Case' },
                    { value: 'OTHER', label: 'Other' },
                  ]"
                  class="check-form-item"
                >
                </CheckSelect>
              </template>
            </CheckInput>
          </ByFormItem>
          <ByFormItem prop="weight" required class="check-form-item">
            <CheckInput
              ref="weight"
              v-model="formData.weight"
              type='float'
              oninput="if(value>9999999.999)value=value.slice(0,value.length-1);if(value.length>11)value=value.slice(0,11)"
              placeholder="Total Weight"
              :borderRed="weightBorder"
            >
              <template slot="prefix">
                <svg-icon size="20" name="home_ic_weight"></svg-icon>
              </template>
              <template slot="suffix"> KG </template>
            </CheckInput>
          </ByFormItem>

          <ByFormItem prop="volume" required class="check-form-item">
            <CheckInput
              ref="volume"
              v-model="formData.volume"
              type='float'
              oninput="if(value>9999999.999)value=value.slice(0,value.length-1);if(value.length>11)value=value.slice(0,11)"
              placeholder="Total Volume"
              :borderRed="volumeBorder"
            >
              <template slot="prefix">
                <svg-icon size="20" name="home_ic_volume"></svg-icon>
              </template>
              <template slot="suffix"> CBM </template>
            </CheckInput>
          </ByFormItem>

          <ByFormItem :class="['check-form-item']">
            <by-button
              :class="['check__button', { 'button-active': buttonActive }]"
              @click="goCheck"
              >ENQUIRY</by-button
            >
          </ByFormItem>
        </div>
      </ByForm>
    </div>
  </div>
</template>

<script>
import { post } from "@/ask/axios";
import bus from "@/ask/eventBus";
import ByAutocomplete from "./components/ByAutocomplete.vue";
import CheckInput from "./components/CheckInput.vue";
import CheckSelect from "./components/CheckSelect.vue";
import ByForm from "./components/ByForm.vue";
import ByFormItem from "./components/ByFormItem.vue";
export default {
  name: "Air",
  components: {
    ByAutocomplete,
    CheckInput,
    CheckSelect,
    ByForm,
    ByFormItem,
  },
  data() {
    return {
      formData: {
        from: "",
        end: "",
        fromLabel: "",
        unit: "",
        unitType: "CTNS",
        volume: "",
        weight: "",
      },
      volumeBorder: false,
      weightBorder: false,
      rules: {
        // 如果按每件计算，只填写CBM体积无法查价，提示需填写材积信息集合（即长宽高），只填写KG重量同上，即都需要材积
        // 如果按重量计算，则KG重量必填，CBM体积可不填，所以设置重量为必填项
        from: { required: true },
        end: { required: true },
        unit: { required: true },
      },
      startAirDatas: [],
      startHotDatas:[],
      endAirDatas: [],
      //机场数据策略
      airStrategy: {
        //给数据加 value和label   两  字段
        base: function (airs) {
          airs.forEach((ai, index) => {
            airs[index].label = `${ai.CityNameEn} (${ai.Province_NameEn}) `;
            airs[index].value = ai.CityNameEn;
            airs[index].code = "";
          });
          return airs;
        },
        start: function (airs) {
          airs = this.base(airs);
          let allAir = airs
            .map((ai, index) => {
              return ai.CityNameEn;
            })
            .join(",");
          return airs;
        },
        hot:function(airs){
          airs.forEach((ai, index) => {
            airs[index].label = `${ai.CityNameEn} `;
            airs[index].value = ai.CityNameEn;
          });
          return airs;
        },
        end: function (airs) {
          airs.forEach((ai, index) => {
            airs[index].label = `${ai.CountryNameEn} (${ai.CountryID}) `;
            airs[index].value = ai.CountryNameEn;
            airs[index].code = ai.CountryID;
          });
          return airs;
        },
      },
      buttonActive: false,
      hotCityActive:true,
      allCityActive:false,
      componentKey: 0
    };
  },
  watch: {
    formData: {
      handler(val) {
        // debugger;
        // delete val.volume
        // val.forEach((v,k)=>{
        for (let k in val) {
          if (this.rules.hasOwnProperty(k)) {
            if (!val[k] || (!this.formData.volume && !this.formData.weight)) {
              this.buttonActive = false;
              return;
            }
          }
        }

        // })
        this.buttonActive = true;
      },
      deep: true,
    }
  },
  mounted() {
    this.getStartAirport();
    this.getStartCity();
    this.getDestAirApi();
  },
  methods: {
    changeType(val){
      if(val == 1){
        this.hotCityActive = true;
        this.allCityActive = false;
      }
      if(val == 2){
        this.hotCityActive = false;
        this.allCityActive = true;
      }
      this.componentKey += 1; 
    },
    getStartAirport() {
      let that = this;
      let param = {
        // "CityName":this.inputText,
        // CityName: that.formData.fromLabel,
        Type: "Ch", //Ch:查中国城市数据  En：查海外城市数据
        Take: 5000,
      };
      // let url = that.$api02 + "/api/EbayCustomer/City/GetStartCityQuery";
      let url = that.$api04 + "/Basics/api/SysRegion/GetStartCityQuery";
      post(url, param).then(function (res) {
        if (res.Results) {
          that.startAirDatas = that.airStrategy["start"](res.Results);
          console.log(that.startAirDatas);
        }
      });
    },
    getStartCity() {
      let that = this;
      // 热门城市
      let param = {
        DataClass: 1,
      };
      // const url = that.$api01 + "/api/HotData/QueryHot";
      const url = that.$api04 + "/Basics/api/HotData/QueryHot";
      post(url, param).then(function (res) {
      console.log("====res1",res);
        if (res.IsOK) {
          let list = [];
          res.Results.forEach(item=>{
            list.push({
            CityCode:item.DataCode,
            CityKey:item.DataKey,
            CityNameCh:item.NameCh,
            CityNameEn:item.NameEn,
            //CountryID:item.DataCode,
            })
          })
          that.startHotDatas = that.airStrategy["hot"](list);
        }
      })
    },
    //起时机场数据
    // getStartAirport() {
    //   let url = this.$api01 + "/api/StartAirPort/StartAirportQuery";
    //   post(url).then((res) => {
    //     //console.log("🚀 ~ res", res);
    //     this.startAirDatas = this.airStrategy["start"](res.Results);
    //   });
    // },
    //目的机场-接口
    getDestAirApi() {
      let that = this;
      let param = {
        Name: "",
        Take: 5000,
      };
      // let url = that.$api02 + "/api/EbayCustomer/Country/EndGetCountry";
      let url = that.$api04 + "/Basics/api/SysRegion/EndGetCountry";
      post(url, param).then(function (res) {
        that.endAirDatas = that.airStrategy["end"](res.Results);
      });
    },
    //调用弹窗去查价
    goCheck() {
      this.$refs["ruleForm"].validate((valid) => {
        if (typeof valid === "string") {
          return this.$refs[valid].focus();
        }
        if (!this.formData.volume && !this.formData.weight) {
          this.weightBorder = true;
          this.volumeBorder = true;
          return;
        } else {
          this.weightBorder = false;
          this.volumeBorder = false;
        }
        // console.log("🚀 ~ goCheck",this.formData);
        // return;
        //   this.addField();
        this.$emit("checkBtn", this.formData, "express");
      });
    },

    // //增加跳转多传的字段
    // addField() {
    //   //   目的地  'AirportNameEn','CountryNameEn'
    //   const selectEnd = this.endAirDatas.find((air) => {
    //     return air.AirportCode3 === this.formData.end;
    //   });
    // //   this.formData["code2En"] = selectEnd.AirportNameEn;
    // //   this.formData["code2Country"] = selectEnd.CountryNameEn;
    //   this.formData["startItem"]=selectEnd
    //   //    起始地 ,'AirportNameEn'
    //   const selectStart = this.startAirDatas.find((air) => {
    //     return air.AirportCode3 === this.formData.from;
    //   });
    //   this.formData["endItem"]=selectStart

    // },
    //筛选数据的函数
    fetchSuggestions(queryString, cb, lists) {

      var datas = lists;
      console.log("====datas",datas);
      var results = queryString ? datas.filter(this.createFilter(queryString)) : datas;
      cb(results);
      // console.log("results", results);
    },
    // 筛选数据的方式
    createFilter(queryString) {
      return (air) => {
        console.log("======air",air,queryString);
        let value = '';
        value = air.code ? air.code : air.label;
        //console.log("======air11",value.toLowerCase(),queryString.toLowerCase(),air.code.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
        return (air.code ? air.code.toLowerCase().indexOf(queryString.toLowerCase()) === 0 :false) ||
        air.label.toLowerCase().indexOf(queryString.toLowerCase()) === 0
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.check-form_flex {
  display: flex;
  .check-form-item {
    flex: 1;
  }
}
// .check-form__group{
//     .check-form-item + .check-form-item {
//   margin-left: 30px;
// }
// }

// .check-center .check__button{
//   background: #96aedc;
//   transition: all .2s ease-in-out;
// }
.check__button.button-active {
  background: #fff;
}
.tabtype{
  background-color: #577ec7;
  color: #ffffff;
  font-size: 14px;
  width: 80px;
  text-align: center;
  div{
    height: 39px;
    line-height: 39px;
    cursor: pointer;
    &:hover{
          //background: #96aedc;
          color: #004fb1;
    }
  }
  .active{
    color: #004fb1;
    background: #96aedc;
  }
}
.check-form-item{
  /deep/ .el-scrollbar__wrap{
    //display: contents !important;
    margin-bottom: 0px !important;
    background-color: #577ec7;
    min-height: 80px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/reception/checkPrice/Express.vue